import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StatisticsComponent } from '../statistics/statistics.component';
import { ConfigureFacebookPagesComponent } from '../configure-facebook-pages/configure-facebook-pages.component'; // update path if needed
import { ConfigureWhatsappBusinessComponent } from '../configure-whatsapp-business/configure-whatsapp-business.component';
import { ConfigureGoogleCalendarComponent } from '../configure-google-calendar/configure-google-calendar.component';
import { ConfigureZoomMeetingsComponent } from '../configure-zoom-meetings/configure-zoom-meetings.component';


@Component({
  selector: 'app-list-integrations',
  templateUrl: './list-integrations.component.html',
  styleUrls: ['./list-integrations.component.scss']
  
})

export class ListIntegrationsComponent {
  activeTab: string = 'overview';

  setTab(tab: string) {
    this.activeTab = tab;
  }
  connectedIntegrations = [
  {
    name: 'Facebook Pages',
    date: '2024-01-15',
    icon: 'chat',
    colorClass: 'blue'
  },
  {
    name: 'WhatsApp Business',
    date: '2024-01-16',
    icon: 'phone',
    colorClass: 'green'
  },
  {
    name: 'Google Calendar',
    date: '2024-01-17',
    icon: 'calendar_today',
    colorClass: 'red'
  },
  {
    name: 'Zoom Meetings',
    date: '2024-01-18',
    icon: 'videocam',
    colorClass: 'purple'
  }
];

closeBtn(): void {
    console.log('Close button clicked');
  }

  autoSyncEnabled = true;
  realTimeNotificationsEnabled = true;
  syncFrequency = '15';
  dataRetention = '90';
 
  constructor(private dialog: MatDialog) {}


openSettingsDialog(integrationName: string): void {
  switch (integrationName) {
    case 'Facebook Pages':
      this.openFacebookConfigDialog();
      break;

    case 'WhatsApp Business':
      this.openWhatsappConfig();
      break;

    case 'Google Calendar':
      this.openGoogleCalendarConfig();
      break;

    case 'Zoom Meetings':
      this.openZoomConfigDialog();
      break;

    default:
      console.warn('No configuration dialog found for:', integrationName);
  }
}



openStatisticsPopup(): void {
  this.dialog.open(StatisticsComponent, {
    width: '600px',
    panelClass: 'stats-dialog',
    data: {} 
  });
}

openFacebookConfigDialog(): void {
  this.dialog.open(ConfigureFacebookPagesComponent, {
    width: '600px',
    panelClass: 'custom-dialog-container'
  });
}

openWhatsappConfig(): void {
  this.dialog.open(ConfigureWhatsappBusinessComponent, {
    width: '500px',
    panelClass: 'whatsapp-dialog',
    disableClose: true,
  });
}

openGoogleCalendarConfig(): void {
  this.dialog.open(ConfigureGoogleCalendarComponent, {
    width: '500px',
    panelClass: 'google-calendar-dialog',
    disableClose: true
  });
}
openZoomConfigDialog(): void {
  this.dialog.open(ConfigureZoomMeetingsComponent, {
    width: '600px',
    panelClass: 'custom-dialog-container'
  });
}

}

